import D2C_TariffPersonal from './Personal'

class D2C_TariffPersonalAnnual extends D2C_TariffPersonal {
  isAnnual = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5b9f4e86b42e24770225851a'
  static tariffTitle = 'Personal annual'
  static order = 35
}

export default D2C_TariffPersonalAnnual
